var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescendingSorting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3078_2556",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3078_2556",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACbUlEQVR4nO3dzWrUUACG4U/Be3DvBbiQgtKOxb9Wca1716IMuJkbUPFiXLp34VJwJSLowimKCCr+dKYL2ylHjiAhYZrkZPI1533gbNI2TfOSzCSnTSUAAAAAAAAAAAArpySdSL3SJ5LmkhYDGTuSbqh7tyV9l/RT0q2UK14McEzVvc//fb9PKVfc9847rkEWhZHMY0m7A4txXcc4CJohiBmCmCGIGYKYIYgZgpghiBmCmCGIGYKYIUguQVznQ3ZWNK9hF8T9zq0rguQSxHU+ZLqieY2meFE3QxAzBDFDEDMEMUMQMwQxQxAzBDFDEDMEMUOQXII8kPSD+Q6fIH+Y7/AKckAQryDj+KdZzHfUw4u6GYKYIYgZgpghiBmCmCGIGYKYIYgZggw4SHiq0Ell6oykF5LeS7pjEORu/FXer5JuKkNPCzsy3MvrK8i4sI43YeF5SW8lfUs8vkh6JD/PSnbmuIcgxRhhvFI8fLu803tOXtYk/UoQpU2Qshhhmy6EDz7PLEgwShClaZCqGGGb/jor6WVHp6yH8jVqGaVJkKUxcrcen5lY3EmTDoKUxQjvri4l+DkGZb1hlDpBiFHTRsXpa5IgCDFWFOUoQapiXG66kbnZqBFlWRBidPzua1IjCDF6iFIVpCrGldQbmZvRkihlQYjRY5SyC8rishlHRnpX446te8toFr8WHbgo6TcxvFw74pGy13aiKTyT6l2Dm4fhXzTcV162lkSZxc9pZdrg/Phv7Es6rbxsVTzwbZ4iRvCBILVtF6LM47IkwgXL6wanrI+S7ilf2/GCbzdlDLSzGQcAAAAAAAAAAJCtQ8lYTd7Ge8mNAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescendingSorting);
export default __webpack_public_path__ + "static/media/DescendingSorting.1b943e8463be178dc535eb399a741f04.svg";
export { ForwardRef as ReactComponent };